import { httpClient } from '@bcba/client-auth';
import {
  ExplorerSearchDigitalDossierSerializer,
  PaginationSerializer,
} from '@bcba/serializers';
import { ExplorerCreateAccessRequestDto } from './dtos/ExplorerCreateAccessRequest.dto';

const apiRoute = `/digital-dossier-access-requests`;

export type DigitalDossierSearchResult = PaginationSerializer<
  ExplorerSearchDigitalDossierSerializer[]
>;

export const postCreateAccessRequest = async ({
  uuid,
}: ExplorerCreateAccessRequestDto) => {
  const { data } = await httpClient.post<void>(apiRoute, {
    uuid,
  });

  return data;
};
